import { Button, Card, Typography } from "@material-tailwind/react";
import moment from "moment";
import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ManifoldReportTable(props) {
  const {
    chngovr_report: chngovrReport,
    ws_report: wsReport,
    br_report: brReport,
  } = props.controllerDetails?.reportInfo?.[0] || {};

  const handleManifoldReportDownload = () => {
    // Retrieve report statuses
    const { chngovr_report, ws_report, br_report } =
      props.controllerDetails?.reportInfo?.[0] || {};

    // Define dynamic headings based on report statuses
    const getHeadings = (chngovr, ws, br) => {
      if (chngovr && !ws && !br) {
        return [
          "Manifold",
          "Mode/Cylinder",
          "Date / On Time",
          "Date / Off Time",
          // "Emptying Process Duration",
          "Emptying Process Count",
          "On Pressure",
          "Total Lpg",
          // "Is Emptying?",
          "Emptying Status",
        ];
      } else if (ws && !chngovr && !br) {
        return ["Total LPG Consumption", "Difference"];
      } else if (br && !chngovr && !ws) {
        return ["Avg LPG Consumed", "Total burner running time"];
      } else if (chngovr && ws && !br) {
        return [
          "Manifold",
          "Mode/Cylinder",
          "Date / On Time",
          "Date / Off Time",
          // "Emptying Process Duration",
          "Emptying Process Count",
          "On Pressure",
          "Total Lpg",
          // "Is Emptying?",
          "Emptying Status",
          "Total LPG Consumption",
          "Difference",
        ];
      } else if (chngovr && br && !ws) {
        return [
          "Manifold",
          "Mode/Cylinder",
          "Date / On Time",
          "Date / Off Time",
          // "Emptying Process Duration",
          "Emptying Process Count",
          "On Pressure",
          "Total Lpg",
          // "Is Emptying?",
          "Emptying Status",
          "Avg LPG Consumed",
          "Total burner running time",
        ];
      } else if (ws && br && !chngovr) {
        return [
          "Total LPG Consumption",
          "Difference",
          "Avg LPG Consumed",
          "Total burner running time",
        ];
      } else if (chngovr && ws && br) {
        return [
          "Manifold",
          "Mode/Cylinder",
          "Date / On Time",
          "Date / Off Time",
          // "Emptying Process Duration",
          "Emptying Process Count",
          "On Pressure",
          "Total Lpg",
          // "Is Emptying?",
          "Emptying Status",
          "Total LPG Consumption",
          "Difference",
          "Avg LPG Consumed",
          "Total burner running time",
        ];
      } else {
        return [];
      }
    };

    // Generate headings based on active reports
    const headings = getHeadings(!!chngovr_report, !!ws_report, !!br_report);

    // Generate data rows based on active reports
    const data = props.manifoldReportData.map((item) => {
      const startTime = new Date(item.ps_datetime);
      const endTime = new Date(item.pe_datetime);
      let differenceInMilliseconds = endTime - startTime;
      // let mfrMinutes = item?.mfr * 60 * 1000;
      // let countDiff = item?.postrun_count * mfrMinutes;

      // differenceInMilliseconds = differenceInMilliseconds - countDiff;

      // Ensure the result is not negative
      differenceInMilliseconds = Math.max(differenceInMilliseconds, 0);

      // const hours = String(
      //   Math.floor(differenceInMilliseconds / (1000 * 60 * 60))
      // ).padStart(2, "0");
      // const minutes = String(
      //   Math.floor((differenceInMilliseconds % (1000 * 60 * 60)) / (1000 * 60))
      // ).padStart(2, "0");
      // const seconds = String(
      //   Math.floor((differenceInMilliseconds % (1000 * 60)) / 1000)
      // ).padStart(2, "0");

      if (chngovr_report === 1 && !ws_report && !br_report) {
        return [
          `Manifold ${item.manifold}`,
          item.numOfCylndrCnctd ?? "-",
          item.start_datetime
            ? moment(item.start_datetime).format("DD/MM/YYYY HH:mm")
            : "-",
          item.end_datetime
            ? moment(item.end_datetime).format("DD/MM/YYYY HH:mm")
            : "-",
          // item.ps_datetime && item.pe_datetime && item?.mfr
          //   ? hours + ":" + minutes + ":" + seconds
          //   : "-",
          item.postrun_count || "-",
          item.shift_pr ?? "-",
          item.totalLPGWght ?? "-",
          item.postrun_status === 0
            ? "Running"
            : item.postrun_status === 1
            ? "Completed"
            : item.postrun_status === 3
            ? "Loaded before empty"
            : item.postrun_status === 4
            ? "Emptying process successful"
            : item.postrun_status === 5
            ? "Detected Low Pressure at M2"
            : item.postrun_status === 6
            ? "Detected Low Pressure at M1"
            : "-",
        ];
      } else if (ws_report === 1 && !chngovr_report && !br_report) {
        return [
          item.total_LPG ?? "-",
          item.difToatlLPGCnsmptionNtotalLPG ?? "-",
        ];
      } else if (br_report === 1 && !chngovr_report && !ws_report) {
        return [
          item.avg_LPG ?? "-",
          item.totalBurnerHours !== undefined &&
          item.totalBurnerHours !== null &&
          item.totalBurnerHours != 0
            ? formatTime(item.totalBurnerHours)
            : "-",
        ];
      } else if (chngovr_report === 1 && ws_report === 1 && !br_report) {
        return [
          `Manifold ${item.manifold}`,
          item.numOfCylndrCnctd ?? "-",
          item.start_datetime
            ? moment(item.start_datetime).format("DD/MM/YYYY HH:mm")
            : "-",
          item.end_datetime
            ? moment(item.end_datetime).format("DD/MM/YYYY HH:mm")
            : "-",
          // item.ps_datetime && item.pe_datetime
          //   ? hours + ":" + minutes + ":" + seconds
          //   : "-",
          item.postrun_count || "-",
          item.shift_pr ?? "-",
          item.totalLPGWght ?? "-",
          item.postrun_status === 0
            ? "Running"
            : item.postrun_status === 1
            ? "Completed"
            : item.postrun_status === 3
            ? "Loaded before empty"
            : item.postrun_status === 4
            ? "Emptying process successful"
            : item.postrun_status === 5
            ? "Detected Low Pressure at M2"
            : item.postrun_status === 6
            ? "Detected Low Pressure at M1"
            : "-",
          item.total_LPG ?? "-",
          item.difToatlLPGCnsmptionNtotalLPG ?? "-",
        ];
      } else if (chngovr_report === 1 && !ws_report && br_report === 1) {
        return [
          `Manifold ${item.manifold}`,
          item.numOfCylndrCnctd ?? "-",
          item.start_datetime
            ? moment(item.start_datetime).format("DD/MM/YYYY HH:mm")
            : "-",
          item.end_datetime
            ? moment(item.end_datetime).format("DD/MM/YYYY HH:mm")
            : "-",
          // item.ps_datetime && item.pe_datetime
          //   ? hours + ":" + minutes + ":" + seconds
          //   : "-",
          item.postrun_count || "-",
          item.shift_pr ?? "-",
          item.totalLPGWght ?? "-",
          item.postrun_status === 0
            ? "Running"
            : item.postrun_status === 1
            ? "Completed"
            : item.postrun_status === 3
            ? "Loaded before empty"
            : item.postrun_status === 4
            ? "Emptying process successful"
            : item.postrun_status === 5
            ? "Detected Low Pressure at M2"
            : item.postrun_status === 6
            ? "Detected Low Pressure at M1"
            : "-",
          item.avg_LPG ?? "-",
          item.totalBurnerHours !== undefined &&
          item.totalBurnerHours !== null &&
          item.totalBurnerHours != 0
            ? formatTime(item.totalBurnerHours)
            : "-",
        ];
      } else if (ws_report === 1 && br_report === 1 && !chngovr_report) {
        return [
          item.total_LPG ?? "-",
          item.difToatlLPGCnsmptionNtotalLPG ?? "-",
          item.avg_LPG ?? "-",
          item.totalBurnerHours !== undefined &&
          item.totalBurnerHours !== null &&
          item.totalBurnerHours != 0
            ? formatTime(item.totalBurnerHours)
            : "-",
        ];
      } else if (chngovr_report === 1 && ws_report === 1 && br_report === 1) {
        return [
          `Manifold ${item.manifold}`,
          item.numOfCylndrCnctd ?? "-",
          item.start_datetime
            ? moment(item.start_datetime).format("DD/MM/YYYY HH:mm")
            : "-",
          item.end_datetime
            ? moment(item.end_datetime).format("DD/MM/YYYY HH:mm")
            : "-",
          // item.ps_datetime && item.pe_datetime
          //   ? hours + ":" + minutes + ":" + seconds
          //   : "-",
          item.postrun_count || "-",
          item.shift_pr ?? "-",
          item.totalLPGWght ?? "-",
          item.postrun_status === 0
            ? "Running"
            : item.postrun_status === 1
            ? "Completed"
            : item.postrun_status === 3
            ? "Loaded before empty"
            : item.postrun_status === 4
            ? "Emptying process successful"
            : item.postrun_status === 5
            ? "Detected Low Pressure at M2"
            : item.postrun_status === 6
            ? "Detected Low Pressure at M1"
            : "-",
          item.total_LPG ?? "-",
          item.difToatlLPGCnsmptionNtotalLPG ?? "-",
          item.avg_LPG ?? "-",
          item.totalBurnerHours !== undefined &&
          item.totalBurnerHours !== null &&
          item.totalBurnerHours != 0
            ? formatTime(item.totalBurnerHours)
            : "-",
        ];
      } else {
        return [];
      }
    });

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet([headings, ...data]);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Manifold Changeover Report");

    // Convert workbook to binary string and save the file
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      "manifold_changeover_report.xlsx"
    );
  };

  const formatTime = (fractionalHours) => {
    const totalSeconds = fractionalHours * 3600;
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
      2,
      "0"
    );
    const seconds = String(Math.floor(totalSeconds % 60)).padStart(2, "0");

    return `${hours}:${minutes}:${seconds}`;
  };

  const getHeadings = (chngovrReport, wsReport, brReport) => {
    if (chngovrReport && !wsReport && !brReport) {
      return [
        "Manifold",
        "Mode/Cylinder",
        "Date / On Time",
        "Date / Off Time",
        // "Emptying Process Duration",
        "Emptying Process Count",
        "On Pressure",
        "Total Lpg",
        // "Is Emptying?",
        "Emptying Status",
      ];
    } else if (!chngovrReport && wsReport && !brReport) {
      return ["Total LPG Consumption", "Difference"];
    } else if (!chngovrReport && !wsReport && brReport) {
      return ["Avg LPG Consumed", "total burner running time"];
    } else if (chngovrReport && wsReport && !brReport) {
      return [
        "Manifold",
        "Mode/Cylinder",
        "Date / On Time",
        "Date / Off Time",
        // "Emptying Process Duration",
        "Emptying Process Count",
        "On Pressure",
        "Total Lpg",
        // "Is Emptying?",
        "Emptying Status",
        "Total LPG Consumption",
        "Difference",
      ];
    } else if (chngovrReport && !wsReport && brReport) {
      return [
        "Manifold",
        "Mode/Cylinder",
        "Date / On Time",
        "Date / Off Time",
        // "Emptying Process Duration",
        "Emptying Process Count",
        "On Pressure",
        "Total Lpg",
        // "Is Emptying?",
        "Emptying Status",
        "Avg LPG Consumed",
        "total burner running time",
      ];
    } else if (!chngovrReport && wsReport && brReport) {
      return [
        "Total LPG Consumption",
        "Difference",
        "Avg LPG Consumed",
        "total burner running time",
      ];
    } else if (chngovrReport && wsReport && brReport) {
      return [
        "Manifold",
        "Mode/Cylinder",
        "Date / On Time",
        "Date / Off Time",
        // "Emptying Process Duration",
        "Emptying Process Count",
        "On Pressure",
        "Total Lpg",
        // "Is Emptying?",
        "Emptying Status",
        "Total LPG Consumption",
        "Difference",
        "Avg LPG Consumed",
        "total burner running time",
      ];
    } else {
      return []; // fallback case
    }
  };

  return (
    <>
      <div className="flex flex-col md:flex-row justify-between md:items-center gap-5 font-bold text-2xl text-[#BD3B24]">
        <p className="text-2xl font-bold text-black">
          Manifold Changeover Report
        </p>
        <div className="flex flex-col sm:flex-row items-end sm:items-center justify-end md:justify-[unset] gap-3 sm:gap-0">
          {props.manifoldReportData?.length > 0 && (
            <Button
              onClick={handleManifoldReportDownload}
              className="font-poppins font-medium tracking-wider bg-[#03438D]"
            >
              Download
            </Button>
          )}
        </div>
      </div>

      <div>
        <Card
          className="h-full w-full rounded-none overflow-x-scroll md:overflow-x-hidde mt-4"
          style={{
            boxShadow:
              props.manifoldReportData?.length > 0
                ? "0 4px 8px 0 rgba(0, 0, 0, 0), 0 6px 20px 0 rgba(0, 0, 0, 0.06)"
                : "none",
          }}
        >
          <table>
            <thead>
              <tr>
                {getHeadings(!!chngovrReport, !!wsReport, !!brReport).map(
                  (head, index) => (
                    <th key={index} className="bg-[#03438D] p-4 text-center">
                      <Typography
                        variant="small"
                        color="blue-gray"
                        className="font-poppins text-white uppercase font-normal tracking-wider"
                      >
                        {head}
                      </Typography>
                    </th>
                  )
                )}
              </tr>

              {/* <tr>
                {props.controllerDetails?.reportInfo?.[0]?.chngovr_report ===
                  1 &&
                props.controllerDetails?.reportInfo?.[0]?.ws_report === 0 &&
                props.controllerDetails?.reportInfo?.[0]?.bs_report === 0
                  ? [1, 2, 3, 4, 5]
                  : props.controllerDetails?.reportInfo?.[0]?.chngovr_report ===
                      0 &&
                    props.controllerDetails?.reportInfo?.[0]?.ws_report === 1 &&
                    props.controllerDetails?.reportInfo?.[0]?.bs_report === 0
                  ? [1, 2, 3]
                  : props.controllerDetails?.reportInfo?.[0]?.chngovr_report ===
                      0 &&
                    props.controllerDetails?.reportInfo?.[0]?.ws_report === 0 &&
                    props.controllerDetails?.reportInfo?.[0]?.bs_report === 1
                  ? [1, 2]
                  : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((head) => (
                      <th key={head} className="bg-[#03438D] p-4 text-center">
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-poppins text-white uppercase font-normal tracking-wider"
                        >
                          {head}
                        </Typography>
                      </th>
                    ))}
                <th
                  className="bg-[#03438D] p-4 text-center"
                  colSpan={4} // Spans across 4 columns
                >
                  <Typography
                    variant="small"
                    color="blue-gray"
                    className="font-poppins text-white uppercase font-normal tracking-wider"
                  >
                    Running Time
                  </Typography>
                </th>
              </tr>
              <tr>
                {Array.from({ length: 13 }, (_, i) => i + 1).map((item, i) => (
                  <th
                    className="border-b border-blue-gray-100 bg-[#03438D] p-4"
                    key={i}
                  >
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="font-poppins text-white uppercase font-normal tracking-wider"
                    >
                      {""}
                    </Typography>
                  </th>
                ))}
                {Array.from(
                  { length: props.manifoldReportData[0].numOfBurners ?? 0 },
                  (_, i) => i + 1
                ).map((item, i) => (
                  <th
                    className="border-b border-blue-gray-100 bg-[#03438D] p-4 text-center"
                    key={i}
                  >
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="font-poppins text-white uppercase font-normal tracking-wider"
                    >
                      Burner {i + 1}
                    </Typography>
                  </th>
                ))}
              </tr> */}
            </thead>

            <tbody>
              {props.manifoldReportData &&
                props.manifoldReportData.map((item, index) => {
                  const startTime = new Date(item.ps_datetime);
                  const endTime = new Date(item.pe_datetime);
                  let differenceInMilliseconds = endTime - startTime;
                  // let mfrMinutes = item?.mfr * 60 * 1000;
                  // let countDiff = item?.postrun_count * mfrMinutes;

                  // Subtract postrun count in minutes (postrun_count * 60 * 1000 milliseconds)
                  // differenceInMilliseconds =
                  //   differenceInMilliseconds - 1 * 60 * 1000;

                  // differenceInMilliseconds =
                  //   differenceInMilliseconds - countDiff;

                  // Ensure the result is not negative
                  differenceInMilliseconds = Math.max(
                    differenceInMilliseconds,
                    0
                  );

                  // const hours = String(
                  //   Math.floor(differenceInMilliseconds / (1000 * 60 * 60))
                  // ).padStart(2, "0");
                  // const minutes = String(
                  //   Math.floor(
                  //     (differenceInMilliseconds % (1000 * 60 * 60)) /
                  //       (1000 * 60)
                  //   )
                  // ).padStart(2, "0");
                  // const seconds = String(
                  //   Math.floor((differenceInMilliseconds % (1000 * 60)) / 1000)
                  // ).padStart(2, "0");

                  return (
                    <tr
                      key={index}
                      className={`${item.manifold == 1 ? "bg-[#e6eefe]" : ""}`}
                    >
                      {props.controllerDetails?.reportInfo?.[0]
                        ?.chngovr_report === 1 && (
                        <>
                          <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-medium"
                            >
                              Manifold {item.manifold}
                            </Typography>
                          </td>
                          <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-medium"
                            >
                              {item.numOfCylndrCnctd ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className={`font-poppins font-medium`}
                            >
                              {item.start_datetime
                                ? moment(item.start_datetime).format(
                                    "DD/MM/YYYY HH:mm"
                                  )
                                : "-"}
                            </Typography>
                          </td>
                          <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-medium"
                            >
                              {item.end_datetime
                                ? moment(item.end_datetime).format(
                                    "DD/MM/YYYY HH:mm"
                                  )
                                : "-"}
                            </Typography>
                          </td>
                          {/* <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-medium"
                            >
                              {item.ps_datetime && item.pe_datetime && item?.mfr
                                ? hours + ":" + minutes + ":" + seconds
                                : "-"}
                            </Typography>
                          </td> */}
                          <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-medium"
                            >
                              {item.postrun_count || "-"}
                            </Typography>
                          </td>
                          <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-medium"
                            >
                              {item.shift_pr ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-medium"
                            >
                              {/* {item.totalLPGWght ?? "-"} */}
                              {item.numOfCylndrCnctd == "AL" ||
                              item.numOfCylndrCnctd == "SW"
                                ? "NA"
                                : item.totalLPGWght ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className={`font-poppins font-medium ${
                                item.postrun_status === 0
                                  ? "text-red-600"
                                  : item.postrun_status === 1
                                  ? "text-green-600"
                                  : ""
                              }`}
                            >
                              {item.postrun_status === 0
                                ? "Running"
                                : item.postrun_status === 1
                                ? "Completed"
                                : item.postrun_status === 3
                                ? "Loaded before empty"
                                : item.postrun_status === 4
                                ? "Emptying process successful"
                                : item.postrun_status === 5
                                ? "Detected Low Pressure at M2"
                                : item.postrun_status === 6
                                ? "Detected Low Pressure at M1"
                                : "-"}
                            </Typography>
                          </td>
                        </>
                      )}

                      {props.controllerDetails?.reportInfo?.[0]?.ws_report ===
                        1 && (
                        <>
                          <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-medium"
                            >
                              {item.total_LPG ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-medium"
                            >
                              {item.difToatlLPGCnsmptionNtotalLPG ?? "-"}
                            </Typography>
                          </td>
                        </>
                      )}
                      {props.controllerDetails?.reportInfo?.[0]?.br_report ===
                        1 && (
                        <>
                          <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-medium"
                            >
                              {item.avg_LPG ?? "-"}
                            </Typography>
                          </td>
                          <td className="p-4 text-center">
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-poppins font-medium"
                            >
                              {item.totalBurnerHours !== undefined &&
                              item.totalBurnerHours !== null &&
                              item.totalBurnerHours != 0
                                ? formatTime(item.totalBurnerHours)
                                : "-"}
                            </Typography>
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Card>
      </div>
    </>
  );
}

export default ManifoldReportTable;
